import { fetchDocumentMetadata } from './fetchDocumentMetadata';

export type CSRFToken = { headerName: string | null; token: string | null };

/**
 * Fetches csrf fields from the parent JSP
 */
export const fetchCsrf = (document: Document): CSRFToken => {
  return {
    headerName: fetchDocumentMetadata(document, 'csrf-param'),
    token: fetchDocumentMetadata(document, 'csrf-token'),
  };
};
